module.exports = __webpack_public_path__ + "img/rosemount-wireless-pressure-gauge-1-front.73e738e5.png";